import React from "react";
import {
  Rocket,
  Link,
  ShoppingCart,
  Clock,
  Bell,
  ArrowRight,
} from "lucide-react";
import { ScrollRestoration } from "react-router-dom";

export default function ComingSoon() {
  return (
    <div className="min-h-screen">
      {/* Main Content */}
      <main className="px-6 py-16">
        <div className="max-w-4xl mx-auto text-center">
          {/* Coming Soon Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-100 to-red-100 rounded-full text-orange-700 font-medium mb-8">
            <Clock className="w-4 h-4" />
            Coming Soon
          </div>

          {/* Main Icon */}
          <div className="mb-8">
            <div
              className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-orange-500 to-red-600 rounded-full mb-6"
              style={{ backgroundColor: "#ff7301" }}
            >
              <Rocket className="w-12 h-12 text-white" />
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Seamless Marketplace
            <span
              className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-red-600"
              style={{
                WebkitBackgroundClip: "text",
                backgroundImage: "linear-gradient(to right, #ff7301, #dc2626)",
              }}
            >
              Integration
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto leading-relaxed">
            We're building an amazing feature that will connect your AI
            marketplace orders directly to Passionbits marketplace with just one
            click.
          </p>

          {/* Feature Preview */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-12 max-w-3xl mx-auto">
            <div className="flex items-center justify-center gap-8 mb-8">
              {/* AI Marketplace */}
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-3">
                  <ShoppingCart className="w-8 h-8 text-orange-600" />
                </div>
                <h3 className="font-semibold text-gray-900">AI Marketplace</h3>
                <p className="text-sm text-gray-600">Your current orders</p>
              </div>

              {/* Connection Arrow */}
              <div className="flex flex-col items-center">
                <div
                  className="w-12 h-12 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center mb-3"
                  style={{ backgroundColor: "#ff7301" }}
                >
                  <ArrowRight className="w-6 h-6 text-white" />
                </div>
                <p className="text-sm text-gray-600">One-click connect</p>
              </div>

              {/* Passionbits Marketplace */}
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-3">
                  <Link className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="font-semibold text-gray-900">Passionbits</h3>
                <p className="text-sm text-gray-600">Marketplace orders</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-2">
                How it will work:
              </h4>
              <ul className="text-left text-gray-700 space-y-2">
                <li className="flex items-start gap-3">
                  <span
                    className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"
                    style={{ backgroundColor: "#ff7301" }}
                  ></span>
                  Select items from your AI marketplace
                </li>
                <li className="flex items-start gap-3">
                  <span
                    className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"
                    style={{ backgroundColor: "#ff7301" }}
                  ></span>
                  Click the connect button
                </li>
                <li className="flex items-start gap-3">
                  <span
                    className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"
                    style={{ backgroundColor: "#ff7301" }}
                  ></span>
                  Orders automatically sync to Passionbits marketplace
                </li>
                <li className="flex items-start gap-3">
                  <span
                    className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"
                    style={{ backgroundColor: "#ff7301" }}
                  ></span>
                  Manage everything from one unified dashboard
                </li>
              </ul>
            </div>
          </div>

          {/* Notification Signup */}
          {/* <div
            className="bg-gradient-to-r from-orange-600 to-red-600 rounded-2xl p-8 text-white mb-12"
            style={{
              background: `linear-gradient(to right, #ff7301, #dc2626)`,
            }}
          >
            <div className="flex items-center justify-center gap-3 mb-4">
              <Bell className="w-6 h-6" />
              <h3 className="text-xl font-semibold">Get Notified</h3>
            </div>
            <p className="mb-6 opacity-90">
              Be the first to know when this feature launches!
            </p>
            <div className="flex gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white/20"
              />
              <button className="px-6 py-3 bg-white text-orange-600 rounded-lg font-medium hover:bg-gray-50 transition-colors">
                Notify Me
              </button>
            </div>
          </div> */}

          {/* Timeline */}
          {/* <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Development Timeline
            </h3>
            <div className="inline-flex items-center gap-4 bg-white rounded-xl p-6 shadow-lg">
              <div className="text-center">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-2">
                  <span className="text-green-600 font-bold">✓</span>
                </div>
                <p className="text-sm font-medium text-gray-900">Planning</p>
                <p className="text-xs text-gray-600">Completed</p>
              </div>
              <div className="w-8 h-0.5 bg-gray-200"></div>
              <div className="text-center">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-2">
                  <span className="text-orange-600 font-bold">⚡</span>
                </div>
                <p className="text-sm font-medium text-gray-900">Development</p>
                <p className="text-xs text-gray-600">In Progress</p>
              </div>
              <div className="w-8 h-0.5 bg-gray-200"></div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-2">
                  <span className="text-gray-400 font-bold">🚀</span>
                </div>
                <p className="text-sm font-medium text-gray-900">Launch</p>
                <p className="text-xs text-gray-600">Coming Soon</p>
              </div>
            </div>
          </div> */}
        </div>
      </main>
      <ScrollRestoration />
    </div>
  );
}
